import { Link } from '@heroui/react';
import { useState } from 'react';

interface IPortCallsMapLegendProps {
	onSelectionChange: (selection: string) => void;
}

const PortCallsMapLegend: React.FC<IPortCallsMapLegendProps> = ({ ...props }) => {
	const [selected, setSelected] = useState('');

	const onSelectionChange = (selection: string) => {
		if (selected === selection) {
			setSelected('');
			props.onSelectionChange('');
			return;
		} else {
			setSelected(selection);
			props.onSelectionChange(selection);
		}
	};

	return (
		<div className="flex space-x-2 text-sm whitespace-nowrap">
			<Link
				className={`flex items-center space-x-2 cursor-pointer text-msi-black-color opacity-50 ${selected !== '' && selected !== 'Discharge' ? 'opacity-50' : 'opacity-100'}`}
				onPress={() => onSelectionChange('Discharge')}
			>
				<span className="w-3 h-3 bg-msi-port-calls-discharge rounded-full"></span>
				<span>Discharge</span>
			</Link>
			<Link
				className={`flex items-center space-x-2 cursor-pointer text-msi-black-color opacity-50 ${selected !== '' && selected !== 'Load' ? 'opacity-50' : 'opacity-100'}`}
				onPress={() => onSelectionChange('Load')}
			>
				<span className="w-3 h-3 bg-msi-port-calls-load rounded-full"></span>
				<span>Load</span>
			</Link>
			<Link
				className={`flex items-center space-x-2 cursor-pointer text-msi-black-color opacity-50 ${selected !== '' && selected !== 'other' ? 'opacity-50' : 'opacity-100'}`}
				onPress={() => onSelectionChange('other')}
			>
				<span className="w-3 h-3 bg-msi-port-calls-other rounded-full"></span>
				<span>Unclassified</span>
			</Link>
		</div>
	);
};

export default PortCallsMapLegend;
